module.exports = __webpack_public_path__ + "static/media/18ECA23.0cfc2dbb.jpg";